const defaultEnv = "prod";
let envConfigs: object = {};
let env: string = "";

/**
 * set config for a specific environment (config will not override existing config for the environment, but merge with it)
 * @param environment any custom env string
 * @param config any config object
 */
export const setEnvConfig = (environment: string, config: object) => {
    const previousEnvConfig = envConfigs[environment] || {};
    envConfigs = {
        ...envConfigs,
        [environment]: {
            ...previousEnvConfig,
            ...config,
        },
    };
};

/**
 * get config for a specific environment
 * @param environment any custom env string (optional - will use env set by setEnv otherwise)
 * @returns config object
 */
export const getEnvConfig = <T>(environment?: string): T => {
    return envConfigs[environment || env || getEnv()] || {};
};

/**
 * set the current environment (used for getEnvConfig)
 * @param environment any custom env string
 */
export const setEnv = (environment: string) => {
    env = environment;
};

export const getEnv = (): string => {
    const env =
        document
            .querySelector("meta[name='ux-env']")
            ?.getAttribute("content") || defaultEnv;
    return env;
};
